import type { RouteRecordRaw } from 'vue-router';
import { resellerRoutesDictionary } from './reseller-routes.dictionary.ts';

export const resellerRoutesConfig: RouteRecordRaw = {
  ...resellerRoutesDictionary.reseller.root,
  redirect: {
    name: resellerRoutesDictionary.reseller.listSplitFiles.name,
  },
  children: [
    {
      ...resellerRoutesDictionary.reseller.listSplitFiles,
      component: () => import('../pages/List/SplitFileListPage.vue'),
    },
  ],
};
